<!-- placeholder for column layout (horizontal alignment) -->
@if (!displayAsText && !displayAsTag && !lmParagraphLayoutInfo) {
  <label
    [ngClass]="{'label lm-placeholder-label no-colon' : true, 'lm-no-label': lmColumnLayoutInfo?.isTable}"
  >&nbsp;</label>
}

<!-- placeholder for paragraph layout (horizontal alignment) -->
@if (!displayAsText && !displayAsTag && label && lmParagraphLayoutInfo?.parentIsParagraphLayout && lmParagraphLayoutInfo?.hasVisibleLabels) {
  <label
    [ngClass]="{'label lm-placeholder-label': true, 'lm-no-label': label?.nolabel }"
  >&nbsp;</label>
}

<div
  [ngClass]="{'disabled-member-field': disabledMemberField, 'lm-checkbox-field-options': true}"
  lm-field-options
  [hasContextMenu]="insertContextMenu"
  [isMemberField]="isCompoundFieldMember"
  [dataEntryMode]="dataEntryMode"
  [isCheckBoxField]="true"
  [ajaxCallbackFunction]="onBeforeContextMenuOpen"
  [contextMenuEventFunction]="contextMenuClicked"
  [buttonId]="fieldOptionsId"
  [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
  [isInAccessibilityMode]="isInAccessibilityMode"
  [displayFieldOptions]="displayFieldOptions"
  [disableFieldOptions]="disableFieldOptions"
  [fieldAutomationId]="fieldAutomationId"
  soho-tooltip
  [popover]="true"
  [title]="popoverTitle"
  [placement]="'right'"
  [trigger]="'click'"
  (click)="onCompoundFieldClickEvent($event)"
  (focus)="onFocus($event)"
  (contextmenu)="onContextMenu($event)"
  (focusin)="onFieldFocus($event)"
  (focusout)="onFieldBlur($event)">
  @switch (displayType) {
    @case (layoutDisplayType.PLAIN) {
      @if (showDirtyCheckboxIndicator) {
        <span class="icon-dirty lm-compound-member-field-dirty"></span>
      }
      <input
        type="checkbox"
        [ngClass]="fieldClassesString"
        [attr.id]="id"
        [attr.bindId]="bindId"
        [readOnly]="(readOnly$ | async) ? true : null"
        [disabled]="(readOnly$ | async) ? true : null"
        [attr.tabindex]="(isInAccessibilityMode && readOnly$ | async) ? null : (isInAccessibilityMode && !isPreviewCompoundMember ? 0 : null)"
        [attr.aria-describedby]="fieldDescriptionId"
        [attr.aria-hidden]="(isInAccessibilityMode && readOnly$ | async) ? 'true' : null"
        [ngModel]="modelField.valueChanged | async"
        (ngModelChange)="onModelChanged($event)"
        soho-checkbox
        soho-alert
        soho-trackdirty
        (dirty)="onDirty($event)"
        (pristine)="onPristine($event)"
        (afterResetDirty)="onAfterResetDirty($event)"
        soho-input-validate
        (error)="onError($event)"
        (valid)="onValid($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        />
        <label
          class='lm-checkbox-label'
          [attr.for]="id"
          [attr.tabindex]="(isInAccessibilityMode && readOnly$ | async) ? 0 : null"
          [attr.role]="(isInAccessibilityMode && readOnly$ | async) ? 'checkbox' : null"
          [attr.aria-checked]="(isInAccessibilityMode && readOnly$ | async) ? ((modelField.valueChanged | async) ? 'true' : 'false') : null"
          [attr.aria-disabled]="(isInAccessibilityMode && readOnly$ | async) ? 'true' : null"
          [attr.aria-required]="(isInAccessibilityMode && readOnly$ | async) ? ((required$ | async) ? 'true' : null) : null"
          soho-label
          [forCheckBox]=true
          [required]="required$ | async"
          lm-label
          [layoutField]="field"
          [personalize]="personalize"
          lm-text-style
          [textStyle]="field?.label?.textStyle"
          >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
        </label>
        <span [class.required]="isRequired" aria-hidden="true"></span>
      }
      @case (layoutDisplayType.SWITCH) {
        <div
          class="switch"
          [ngStyle]="{'display': 'inline-block'}"
          soho-tooltip
          content="{{triggerValueChange | async | booleanAsSwitchTooltip:modelField.value:isReadOnly}}"
          >
          <input
            type="checkbox"
            [ngClass]="fieldClassesString"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [readOnly]="(readOnly$ | async) ? true : null"
            [disabled]="(readOnly$ | async) ? true : null"
            [attr.tabindex]="(isInAccessibilityMode && readOnly$ | async) ? null : (isInAccessibilityMode ? 0 : null)"
            [attr.aria-hidden]="(isInAccessibilityMode && readOnly$ | async) ? 'true' : null"
            [attr.aria-describedby]="fieldDescriptionId"
            [ngModel]="modelField.valueChanged | async"
            (ngModelChange)="onModelChanged($event)"
            soho-alert
            soho-trackdirty
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
            soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
            />
            <label
              class='lm-checkbox-label'
              [attr.for]="id"
              [attr.tabindex]="(isInAccessibilityMode && readOnly$ | async) ? 0 : null"
              [attr.role]="(isInAccessibilityMode && readOnly$ | async) ? 'switch' : null"
              [attr.aria-checked]="(isInAccessibilityMode && readOnly$ | async) ? ((modelField.valueChanged | async) ? 'true' : 'false') : null"
              [attr.aria-disabled]="(isInAccessibilityMode && readOnly$ | async) ? 'true' : null"
              [attr.aria-required]="(isInAccessibilityMode && readOnly$ | async) ? ((required$ | async) ? 'true' : null) : null"
              soho-label
              [required]="required$ | async"
              lm-label
              [layoutField] = "field"
              [personalize]="personalize"
              lm-text-style
              [textStyle]="field?.label?.textStyle"
              >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
            </label>
          </div>
        }
        @case (layoutDisplayType.DISPLAY_AS_TAG) {
          <label
            class='lm-checkbox-label display-as-text-label'
            attr.for="{{id}}"
            soho-label
            lm-label
            [layoutField] = "field"
            [checkBoxIsDisplayAsText]="true"
            [displayInlineBlock]="isCompoundFieldMember"
            lm-text-style
            [textStyle]="field?.label?.textStyle"
            >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
          </label>
          <span class="tag is-dismissible"
            attr.id="{{id}}"
            [ngStyle]="{'color': '#FFFFFF', 'outline': 'none'}"
          [ngClass]="{
            'lm-compound-text': isCompoundFieldMember,
            'lm-text-data ': !isCompoundFieldMember,
            'is-active': isFieldTagFocused,
            'is-focused': isFieldTagFocused,
            'hide-focus': !isFieldTagFocused
           }"
            ngDefaultControl
            [ngModel]="modelField.valueChanged | async"
            (ngModelChange)="onModelChanged($event)"
            soho-alert
            lm-field-style [fieldStyle]="tagStyle?.style" [isTag]="true" [recalculateStyles]="triggerValueChange | async"
            [attr.tabindex]="isInAccessibilityMode ? 0 : null"
            (focus)="onTagFocus()"
            (blur)="onTagBlur()"
          >{{triggerValueChange | async | booleanAsText:modelField.value}}</span>
        }
        @case (layoutDisplayType.DISPLAY_AS_TEXT) {
          <label
            class='lm-checkbox-label display-as-text-label'
            attr.for="{{id}}"
            soho-label
            lm-label
            [layoutField]="field"
            [checkBoxIsDisplayAsText]="true"
            [displayInlineBlock]="isCompoundFieldMember"
            [personalize]="personalize"
            lm-text-style
            [textStyle]="field?.label?.textStyle"
            >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
          </label>
          <p class="hide-white-space"
            attr.id="{{id}}"
            [ngClass]="{'lm-compound-text': lmParagraphLayoutInfo?.previewMode, 'lm-text-data ': !lmParagraphLayoutInfo?.previewMode}"
            [ngStyle]="{'display': 'inline-block'}"
            ngDefaultControl
            [ngModel]="modelField.valueChanged | async"
            (ngModelChange)="onModelChanged($event)"
            soho-alert
            lm-field-style
            [fieldStyle]="field?.fieldStyle"
            [recalculateStyles]="triggerValueChange | async"
            [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
          >{{triggerValueChange | async | booleanAsText:modelField.value}}</p>
        }
      }
    </div>

    <ng-template #mouseOverTextTemplate>
      @if (layoutObject.mouseOverText) {
        <lm-mouse-over-text
          [beforeShowTooltip]="displayMouseOverText"
        ></lm-mouse-over-text>
      }
    </ng-template>

    <span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>

    @if (errorLiveMessage.liveMessage) {
      <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
    }
